'use strict';

const h = require('phy');

const selectUserComponent = props => {
  const { promoCodeV2SelectHtml } = props;
  if (!promoCodeV2SelectHtml) return null;

  return h(
    'div.promo-code-select-info',
    {
      'data-bhw': 'ClickToApplyPromoCodeInfo',
      'data-bh-viewport': 'respect',
    },
    h('div', {
      dangerouslySetInnerHTML: { __html: promoCodeV2SelectHtml },
    })
  );
};

module.exports = selectUserComponent;
